/*-------------  SLIDE 2 animation  -------------*/

var s4headKviz = new Array();

function slide4_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';

	 $(".slide").html('');

		bmcont = '<div id="moveHome"></div><div id="sl4_cnt" class="s4_cnt"></div><div id="sl4_foo" class="menu_bott"></div><div id="slide_kviz1" class="slide1"></div><div id="slide_kviz2" class="slide1"></div><div id="slide_kviz3" class="slide1"></div><div id="slide_kviz4" class="slide1"></div><div id="slide_kviz5" class="slide1"></div>';

		$("#slide4").html(bmcont);

		homepage = '<div id="moveHead"><span class="head-icon"></span><h1>'+jsondata["sl4_head"]+'</h1></div>';
		$("#moveHome").html(homepage);

    $('#slide4').fadeIn(1000);

    returnHome('#moveHome','.slide','');

    bmcont = '<div class="menu"><ul class="menu-kviz">';
    pocet = jsondata["sl4_headline"].length + 1;
    for (i=1; i<pocet; i++) {
      bmcont += '<li id="kviz'+i+'" class="kviz-menu">'+jsondata["sl4_headline"][i-1]+'</li>';
      s4headKviz[i] = jsondata["sl4_headline"][i-1];
    }
		bmcont += '</ul></div><div class="footer"><img src="dist/images/start/pozadi-uvod.png" /></div>';

    $("#sl4_cnt").html(bmcont);

    kviz_menu();
}

function kviz1_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];
  var spatne = new Number(0);
  var spravne = new Number(0);
  var a = 0;

	  $(".slide1").html('');
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl4_kviz1_cnt" class="s4_kviz1_cnt"></div><div id="sl4_foo" class="menu_bott"></div>';
		$("#slide_kviz1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl4_head_kviz"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_kviz1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');

    $(".btn_replay").css("display","none");
    bmcont = '<div class="hometitle">' + s4headKviz[1] + '</div>';
    bmcont += '<ul class="otazka">';
    pocet = jsondata["sl4_kviz1_otazky"].length + 1;
    for (i=1; i<pocet; i++) {
      bmcont += '<li id="otazka'+i+'"><span class="number">'+i+'</span>'+jsondata["sl4_kviz1_otazky"][i-1]+'</li><li class="odpovedi">';
      odpovedi = jsondata["sl4_kviz1_odpovedi"][i-1];
      odpovedi_spravne[i] = jsondata["sl4_kviz1_odpovedi_true"][i-1];
      odpoved = odpovedi.split("|");
      pocet2 = odpoved.length+1;
      if (i == 5 || i == 3) {
        radek = " jedenradek";
      } else {
        radek = "";
      }
      pole[i] = pocet2;
      for (y=1; y<pocet2; y++) {
          bmcont += '<div class="odpoved '+radek+'" id="odpoved_'+i+'_'+y+'"><div class="icon_odpoved"><i class="icon_off"></i></div>'+odpoved[y-1]+ '</div>';
      }
      odpovedi = "";
      bmcont += '</li>'
      if (i==5) {
        bmcont += '</ul><ul class="otazka row2nd">';
      }
    }
    bmcont += '</ul><div class="btn_vysledky" style="display:none;">výsledek testu</div><div class="btn_replay" style="display:none;"><div class="kapkaOK" id="kapkaOK"></div></div>';
    $("#sl4_kviz1_cnt").html(bmcont);
    $(".btn_vysledky").fadeIn(1000);

    bmcont = '<div class="pozadi-grey">';
    pocet = jsondata["sl4_banner"].length;
    for (i=0; i<pocet; i++) {
      a = i+1;
      bmcont += '<div id="box'+a+'">';
      bmcont += jsondata["sl4_banner"][i];
      bmcont += '</div>';
    }
    bmcont += '</div>';

    $("#banner_box").html(bmcont);
    $("#banner_box").css( "z-index", "1" );

    $(".odpoved").on("click", function(){
      var id = $(this).attr("id");
      stavy = id.split("_");
      for (i=1; i<pole[stavy[1]]; i++) {
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').removeClass("icon_on");
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').addClass("icon_off");
      }
      $('#'+id+' .icon_odpoved i').removeClass("icon_off");
      $('#'+id+' .icon_odpoved i').addClass("icon_on");
    });

    $(".btn_vysledky").on("click", function(){
      $(".btn_vysledky").fadeOut(0);
      $(".btn_replay").fadeIn(300);
      pocet = jsondata["sl4_kviz1_odpovedi_true"].length + 1;
      for (i=1; i<pocet; i++) {
        //console.log(odpovedi_spravne[i]);
        stavy = odpovedi_spravne[i].split("|");
        pocet2 = stavy.length;
       for (y=0; y<pocet2; y++) {
         a = y+1;
          stav = $('#odpoved_'+i+'_'+a+' .icon_odpoved i').attr("class");
          //console.log(stavy[y]+" - "+stav+' - #odpoved_'+i+'_'+a);
         if (stavy[y]==='true' && stav=="icon_on") {
            //console.log("spravne");
            spravne++;
            //console.log('spravne = ' + spravne);
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
          } else if (stavy[y]==='false' && stav=="icon_on") {
            //console.log("spatne1");
            spatne++;
            //console.log('spatne = ' + spatne);
            $('#odpoved_'+i+'_'+a+'').css("color","#E30613");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_on");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_off");
          } else if (stavy[y]==='false' && stav=="icon_off") {
            //
            //console.log("spatne2");
          } else if (stavy[y]==='true' && stav=="icon_off") {
            /*for (x=1; x<pocet2; x++) {
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').removeClass("icon_on");
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').addClass("icon_off");
            }*/
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_off");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_on");
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
            //console.log("spatne3");
          } else {
            //console.log("nic");
            $('#odpoved_'+i+'_'+a+'').css("color","#");
          }
        }
      }

      if ((spravne<1) && (spatne<1)) {
        /*var endBox = document.getElementById("box3");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn3','.slide1','');
        $('#znovu_btn3').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz1_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if (spatne>0) {
        /*var endBox = document.getElementById("box2");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn2','.slide1','');
        $('#znovu_btn2').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz1_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if ((spatne==0) && (jsondata["sl4_kviz1_odpovedi_true"].length==spravne)) {
        var endBox = document.getElementById("box1");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );

        returnHome('#zpet_btn1','.slide1','');

        $('#znovu_btn1').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          /*$("#slide1").html('');
          $("#slide1").fadeOut( "slow", function() { });*/
          kviz1_anima();
        });
      }


    });

    $('.btn_replay').on("click", function() {
      $("#banner_box").css( "z-index", "1" );
      $("#banner_box").html('');
      //$("#banner_box").removeAttr('style');
      kviz1_anima();
    });
}

function kviz2_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];
  var spatne = new Number(0);
  var spravne = new Number(0);
  var a = 0;

	  $(".slide1").html('');
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl4_kviz2_cnt" class="s4_kviz1_cnt"></div><div id="sl4_foo" class="menu_bott"></div>';
		$("#slide_kviz1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl4_head_kviz"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_kviz1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');

    $(".btn_replay").css("display","none");
    bmcont = '<div class="hometitle">' + s4headKviz[2] + '</div>';
    bmcont += '<ul class="otazka">';
    pocet = jsondata["sl4_kviz2_otazky"].length + 1;
    for (i=1; i<pocet; i++) {
      bmcont += '<li id="otazka'+i+'"><span class="number">'+i+'</span>'+jsondata["sl4_kviz2_otazky"][i-1]+'</li><li class="odpovedi">';
      odpovedi = jsondata["sl4_kviz2_odpovedi"][i-1];
      odpovedi_spravne[i] = jsondata["sl4_kviz2_odpovedi_true"][i-1];
      odpoved = odpovedi.split("|");
      pocet2 = odpoved.length+1;
      if (i == 1 || i == 8 || i == 9 || i == 10) {
        radek = " jedenradek";
      } else {
        radek = "";
      }
      pole[i] = pocet2;
      for (y=1; y<pocet2; y++) {
          bmcont += '<div class="odpoved '+radek+'" id="odpoved_'+i+'_'+y+'"><div class="icon_odpoved"><i class="icon_off"></i></div>'+odpoved[y-1]+ '</div>';
      }
      odpovedi = "";
      bmcont += '</li>'
      if (i==5) {
        bmcont += '</ul><ul class="otazka row2nd">';
      }
    }
    bmcont += '</ul><div class="btn_vysledky" style="display:none;">výsledek testu</div><div class="btn_replay" style="display:none;"><div class="kapkaOK" id="kapkaOK"></div></div>';
    $("#sl4_kviz2_cnt").html(bmcont);
    $(".btn_vysledky").fadeIn(1000);

    bmcont = '<div class="pozadi-grey">';
    pocet = jsondata["sl4_banner"].length;
    for (i=0; i<pocet; i++) {
      a = i+1;
      bmcont += '<div id="box'+a+'">';
      bmcont += jsondata["sl4_banner"][i];
      bmcont += '</div>';
    }
    bmcont += '</div>';

    $("#banner_box").html(bmcont);
    $("#banner_box").css( "z-index", "1" );

    $(".odpoved").on("click", function(){
      var id = $(this).attr("id");
      stavy = id.split("_");
      for (i=1; i<pole[stavy[1]]; i++) {
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').removeClass("icon_on");
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').addClass("icon_off");
      }
      $('#'+id+' .icon_odpoved i').removeClass("icon_off");
      $('#'+id+' .icon_odpoved i').addClass("icon_on");
    });

    $(".btn_vysledky").on("click", function(){
      $(".btn_vysledky").fadeOut(0);
      $(".btn_replay").fadeIn(300);
      /*var kapkaBox = document.getElementById("kapkaOK");
      TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
      TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});*/
      pocet = jsondata["sl4_kviz2_odpovedi_true"].length + 1;
      for (i=1; i<pocet; i++) {
        //console.log(i + "-" +odpovedi_spravne[i]);
        stavy = odpovedi_spravne[i].split("|");
        pocet2 = stavy.length;
       for (y=0; y<pocet2; y++) {
         a = y+1;
          stav = $('#odpoved_'+i+'_'+a+' .icon_odpoved i').attr("class");
          //console.log(stavy[y]+" - "+stav+' - #odpoved_'+i+'_'+a);
          //console.log (i + "-" + y + "-" + a);
         if (stavy[y]==='true' && stav=="icon_on") {
            //console.log("spravne");
            spravne++;
            //console.log("stavy:true stav:on");
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
          } else if (stavy[y]==='false' && stav=="icon_on") {
            //console.log("spatne1");
            //console.log("stavy:false stav:on");
            spatne++;
            $('#odpoved_'+i+'_'+a+'').css("color","#E30613");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_on");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_off");
          } else if (stavy[y]==='false' && stav=="icon_off") {
            //console.log("stavy:false stav:off");
            //console.log("spatne2");
            /*$('#odpoved_'+i+'_'+a+'').css("color","#E30613");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_on");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_off");*/
          } else if (stavy[y]==='true' && stav=="icon_off") {
            //console.log("stavy:true stav:off");
            /*for (x=1; x<pocet2; x++) {
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').removeClass("icon_on");
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').addClass("icon_off");
            }*/
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_off");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_on");
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
            //console.log("spatne3");
          } else {
            //console.log("nic");
            $('#odpoved_'+i+'_'+a+'').css("color","#");
          }
        }
      }

      if ((spravne<1) && (spatne<1)) {
        /*var endBox = document.getElementById("box3");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn3','.slide1','');
        $('#znovu_btn3').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz2_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if (spatne>0) {
        /*var endBox = document.getElementById("box2");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn2','.slide1','');
        $('#znovu_btn2').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz2_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if ((spatne==0) && (jsondata["sl4_kviz2_odpovedi_true"].length==spravne)) {
        var endBox = document.getElementById("box1");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );

        returnHome('#zpet_btn1','.slide1','');

        $('#znovu_btn1').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          /*$("#slide1").html('');
          $("#slide1").fadeOut( "slow", function() { });*/
          kviz2_anima();
        });
      }

    });

    $('.btn_replay').on("click", function() {
      $("#banner_box").css( "z-index", "1" );
      $("#banner_box").html('');
      //$("#banner_box").removeAttr('style');
      kviz2_anima();
    });
}

function kviz3_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];
  var spatne = new Number(0);
  var spravne = new Number(0);
  var a = 0;

	  $(".slide1").html('');
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl4_kviz3_cnt" class="s4_kviz1_cnt"></div><div id="sl4_foo" class="menu_bott"></div>';
		$("#slide_kviz3").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl4_head_kviz"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_kviz3').fadeIn(1000);
    returnHome('#movePrev','.slide1','');

    $(".btn_replay").css("display","none");
    bmcont = '<div class="hometitle">' + s4headKviz[3] + '</div>';
    bmcont += '<ul class="otazka">';
    pocet = jsondata["sl4_kviz3_otazky"].length + 1;
    for (i=1; i<pocet; i++) {
      bmcont += '<li id="otazka'+i+'"><span class="number">'+i+'</span>'+jsondata["sl4_kviz3_otazky"][i-1]+'</li><li class="odpovedi">';
      odpovedi = jsondata["sl4_kviz3_odpovedi"][i-1];
      odpovedi_spravne[i] = jsondata["sl4_kviz3_odpovedi_true"][i-1];
      odpoved = odpovedi.split("|");
      pocet2 = odpoved.length+1;
      if (i == 1 || i == 3 || i == 6 || i == 7 || i == 8) {
        radek = " jedenradek";
      } else {
        radek = "";
      }
      pole[i] = pocet2;
      for (y=1; y<pocet2; y++) {
          bmcont += '<div class="odpoved '+radek+'" id="odpoved_'+i+'_'+y+'"><div class="icon_odpoved"><i class="icon_off"></i></div>'+odpoved[y-1]+ '</div>';
      }
      odpovedi = "";
      bmcont += '</li>'
      if (i==5) {
        bmcont += '</ul><ul class="otazka row2nd">';
      }
    }
    bmcont += '</ul><div class="btn_vysledky" style="display:none;">výsledek testu</div><div class="btn_replay" style="display:none;"><div class="kapkaOK" id="kapkaOK"></div></div>';
    $("#sl4_kviz3_cnt").html(bmcont);
    $(".btn_vysledky").fadeIn(1000);

    bmcont = '<div class="pozadi-grey">';
    pocet = jsondata["sl4_banner"].length;
    for (i=0; i<pocet; i++) {
      a = i+1;
      bmcont += '<div id="box'+a+'">';
      bmcont += jsondata["sl4_banner"][i];
      bmcont += '</div>';
    }
    bmcont += '</div>';

    $("#banner_box").html(bmcont);
    $("#banner_box").css( "z-index", "1" );

    $(".odpoved").on("click", function(){
      var id = $(this).attr("id");
      stavy = id.split("_");
      for (i=1; i<pole[stavy[1]]; i++) {
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').removeClass("icon_on");
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').addClass("icon_off");
      }
      $('#'+id+' .icon_odpoved i').removeClass("icon_off");
      $('#'+id+' .icon_odpoved i').addClass("icon_on");
    });

    $(".btn_vysledky").on("click", function(){
      $(".btn_vysledky").fadeOut(0);
      $(".btn_replay").fadeIn(300);
      /*var kapkaBox = document.getElementById("kapkaOK");
      TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
      TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});*/
      pocet = jsondata["sl4_kviz3_odpovedi_true"].length + 1;
      for (i=1; i<pocet; i++) {
        //console.log(odpovedi_spravne[i]);
        stavy = odpovedi_spravne[i].split("|");
        pocet2 = stavy.length;
       for (y=0; y<pocet2; y++) {
         a = y+1;
          stav = $('#odpoved_'+i+'_'+a+' .icon_odpoved i').attr("class");
          //console.log(stavy[y]+" - "+stav+' - #odpoved_'+i+'_'+a);
         if (stavy[y]==='true' && stav=="icon_on") {
            //console.log("spravne");
            spravne++;
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
          } else if (stavy[y]==='false' && stav=="icon_on") {
            //console.log("spatne1");
            spatne++;
            $('#odpoved_'+i+'_'+a+'').css("color","#E30613");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_on");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_off");
          } else if (stavy[y]==='false' && stav=="icon_off") {
            //
          } else if (stavy[y]==='true' && stav=="icon_off") {
            /*for (x=1; x<pocet2; x++) {
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').removeClass("icon_on");
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').addClass("icon_off");
            }*/
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_off");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_on");
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
            //console.log("spatne2");
          } else {
            //console.log("nic");
            $('#odpoved_'+i+'_'+a+'').css("color","#");
          }
        }
      }

      if ((spravne<1) && (spatne<1)) {
        /*var endBox = document.getElementById("box3");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn3','.slide1','');
        $('#znovu_btn3').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz3_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if (spatne>0) {
        /*var endBox = document.getElementById("box2");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn2','.slide1','');
        $('#znovu_btn2').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz3_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if ((spatne==0) && (jsondata["sl4_kviz3_odpovedi_true"].length==spravne)) {
        var endBox = document.getElementById("box1");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );

        returnHome('#zpet_btn1','.slide1','');

        $('#znovu_btn1').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          /*$("#slide1").html('');
          $("#slide1").fadeOut( "slow", function() { });*/
          kviz3_anima();
        });
      }
    });

    $('.btn_replay').on("click", function() {
      $("#banner_box").css( "z-index", "1" );
      $("#banner_box").html('');
      //$("#banner_box").removeAttr('style');
      kviz3_anima();
    });
}


function kviz4_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];
  var spatne = new Number(0);
  var spravne = new Number(0);
  var a = 0;

	  $(".slide1").html('');
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl4_kviz4_cnt" class="s4_kviz1_cnt"></div><div id="sl4_foo" class="menu_bott"></div>';
		$("#slide_kviz4").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl4_head_kviz"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_kviz4').fadeIn(1000);
    returnHome('#movePrev','.slide1','');

    $(".btn_replay").css("display","none");
    bmcont = '<div class="hometitle">' + s4headKviz[4] + '</div>';
    bmcont += '<ul class="otazka">';
    pocet = jsondata["sl4_kviz4_otazky"].length + 1;
    for (i=1; i<pocet; i++) {
      bmcont += '<li id="otazka'+i+'"><span class="number">'+i+'</span>'+jsondata["sl4_kviz4_otazky"][i-1]+'</li><li class="odpovedi">';
      odpovedi = jsondata["sl4_kviz4_odpovedi"][i-1];
      odpovedi_spravne[i] = jsondata["sl4_kviz4_odpovedi_true"][i-1];
      odpoved = odpovedi.split("|");
      pocet2 = odpoved.length+1;
      if (i == 1 || i == 2 || i == 3 || i == 4 || i == 5 || i == 6 || i == 7) {
        radek = " jedenradek";
      } else {
        radek = "";
      }
      pole[i] = pocet2;
      for (y=1; y<pocet2; y++) {
          bmcont += '<div class="odpoved '+radek+'" id="odpoved_'+i+'_'+y+'"><div class="icon_odpoved"><i class="icon_off"></i></div>'+odpoved[y-1]+ '</div>';
      }
      odpovedi = "";
      bmcont += '</li>'
      if (i==4) {
        bmcont += '</ul><ul class="otazka row2nd">';
      }
    }
    bmcont += '</ul><div class="btn_vysledky" style="display:none;">výsledek testu</div><div class="btn_replay" style="display:none;"><div class="kapkaOK" id="kapkaOK"></div></div>';
    $("#sl4_kviz4_cnt").html(bmcont);
    $(".btn_vysledky").fadeIn(1000);

    bmcont = '<div class="pozadi-grey">';
    pocet = jsondata["sl4_banner"].length;
    for (i=0; i<pocet; i++) {
      a = i+1;
      bmcont += '<div id="box'+a+'">';
      bmcont += jsondata["sl4_banner"][i];
      bmcont += '</div>';
    }
    bmcont += '</div>';

    $("#banner_box").html(bmcont);
    $("#banner_box").css( "z-index", "1" );

    $(".odpoved").on("click", function(){
      var id = $(this).attr("id");
      stavy = id.split("_");
      for (i=1; i<pole[stavy[1]]; i++) {
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').removeClass("icon_on");
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').addClass("icon_off");
      }
      $('#'+id+' .icon_odpoved i').removeClass("icon_off");
      $('#'+id+' .icon_odpoved i').addClass("icon_on");
    });

    $(".btn_vysledky").on("click", function(){
      $(".btn_vysledky").fadeOut(0);
      $(".btn_replay").fadeIn(300);
      /*var kapkaBox = document.getElementById("kapkaOK");
      TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
      TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});*/
      pocet = jsondata["sl4_kviz4_odpovedi_true"].length + 1;
      for (i=1; i<pocet; i++) {
        //console.log(odpovedi_spravne[i]);
        stavy = odpovedi_spravne[i].split("|");
        pocet2 = stavy.length;
       for (y=0; y<pocet2; y++) {
         a = y+1;
          stav = $('#odpoved_'+i+'_'+a+' .icon_odpoved i').attr("class");
          //console.log(stavy[y]+" - "+stav+' - #odpoved_'+i+'_'+a);
         if (stavy[y]==='true' && stav=="icon_on") {
            //console.log("spravne");
            spravne++;
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
          } else if (stavy[y]==='false' && stav=="icon_on") {
            //console.log("spatne1");
            spatne++;
            $('#odpoved_'+i+'_'+a+'').css("color","#E30613");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_on");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_off");
          } else if (stavy[y]==='false' && stav=="icon_off") {
            //
          } else if (stavy[y]==='true' && stav=="icon_off") {
            /*for (x=1; x<pocet2; x++) {
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').removeClass("icon_on");
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').addClass("icon_off");
            }*/
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_off");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_on");
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
            //console.log("spatne2");
          } else {
            //console.log("nic");
            $('#odpoved_'+i+'_'+a+'').css("color","#");
          }
        }
      }

      if ((spravne<1) && (spatne<1)) {
        /*var endBox = document.getElementById("box3");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn3','.slide1','');
        $('#znovu_btn3').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz4_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if (spatne>0) {
        /*var endBox = document.getElementById("box2");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn2','.slide1','');
        $('#znovu_btn2').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz4_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if ((spatne==0) && (jsondata["sl4_kviz4_odpovedi_true"].length==spravne)) {
        var endBox = document.getElementById("box1");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );

        returnHome('#zpet_btn1','.slide1','');

        $('#znovu_btn1').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          /*$("#slide1").html('');
          $("#slide1").fadeOut( "slow", function() { });*/
          kviz4_anima();
        });
      }
    });

    $('.btn_replay').on("click", function() {
      $("#banner_box").css( "z-index", "1" );
      $("#banner_box").html('');
      //$("#banner_box").removeAttr('style');
      kviz4_anima();
    });
}

function kviz5_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';
  var odpoved = [];
  var pole = [];
  var odpovedi_spravne = [];
  var stavy = [];
  var spatne = new Number(0);
  var spravne = new Number(0);
  var a = 0;

	  $(".slide1").html('');
    $("#help").fadeOut(1000);
		bmcont = '<div id="movePrev"></div><div id="sl4_kviz5_cnt" class="s4_kviz1_cnt"></div><div id="sl4_foo" class="menu_bott"></div>';
		$("#slide_kviz1").html(bmcont);
		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl4_head_kviz"]+'</h1></div>';
    $("#movePrev").html(homepage);
    $('#slide_kviz1').fadeIn(1000);
    returnHome('#movePrev','.slide1','');

    $(".btn_replay").css("display","none");
    bmcont = '<div class="hometitle">' + s4headKviz[5] + '</div>';
    bmcont += '<ul class="otazka">';
    pocet = jsondata["sl4_kviz5_otazky"].length + 1;
    for (i=1; i<pocet; i++) {
      bmcont += '<li id="otazka'+i+'"><span class="number">'+i+'</span>'+jsondata["sl4_kviz5_otazky"][i-1]+'</li><li class="odpovedi">';
      odpovedi = jsondata["sl4_kviz5_odpovedi"][i-1];
      odpovedi_spravne[i] = jsondata["sl4_kviz5_odpovedi_true"][i-1];
      odpoved = odpovedi.split("|");
      pocet2 = odpoved.length+1;
      if (i == 7 || i == 8 || i == 9 || i == 3) {
        radek = " jedenradek";
      } else {
        radek = "";
      }
      pole[i] = pocet2;
      for (y=1; y<pocet2; y++) {
          bmcont += '<div class="odpoved '+radek+'" id="odpoved_'+i+'_'+y+'"><div class="icon_odpoved"><i class="icon_off"></i></div>'+odpoved[y-1]+ '</div>';
      }
      odpovedi = "";
      bmcont += '</li>'
      if (i==5) {
        bmcont += '</ul><ul class="otazka row2nd">';
      }
    }
    bmcont += '</ul><div class="btn_vysledky" style="display:none;">výsledek testu</div><div class="btn_replay" style="display:none;"><div class="kapkaOK" id="kapkaOK"></div></div>';
    $("#sl4_kviz5_cnt").html(bmcont);
    $(".btn_vysledky").fadeIn(1000);

    bmcont = '<div class="pozadi-grey">';
    pocet = jsondata["sl4_banner"].length;
    for (i=0; i<pocet; i++) {
      a = i+1;
      bmcont += '<div id="box'+a+'">';
      bmcont += jsondata["sl4_banner"][i];
      bmcont += '</div>';
    }
    bmcont += '</div>';

    $("#banner_box").html(bmcont);
    $("#banner_box").css( "z-index", "1" );

    $(".odpoved").on("click", function(){
      var id = $(this).attr("id");
      stavy = id.split("_");
      for (i=1; i<pole[stavy[1]]; i++) {
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').removeClass("icon_on");
          $('#odpoved_'+stavy[1]+'_'+i+' .icon_odpoved i').addClass("icon_off");
      }
      $('#'+id+' .icon_odpoved i').removeClass("icon_off");
      $('#'+id+' .icon_odpoved i').addClass("icon_on");
    });

    $(".btn_vysledky").on("click", function(){
      $(".btn_vysledky").fadeOut(0);
      $(".btn_replay").fadeIn(300);
      /*var kapkaBox = document.getElementById("kapkaOK");
      TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
      TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});*/
      pocet = jsondata["sl4_kviz5_odpovedi_true"].length + 1;
      for (i=1; i<pocet; i++) {
        //console.log(odpovedi_spravne[i]);
        stavy = odpovedi_spravne[i].split("|");
        pocet2 = stavy.length;
       for (y=0; y<pocet2; y++) {
         a = y+1;
          stav = $('#odpoved_'+i+'_'+a+' .icon_odpoved i').attr("class");
          //console.log(stavy[y]+" - "+stav+' - #odpoved_'+i+'_'+a);
         if (stavy[y]==='true' && stav=="icon_on") {
            //console.log("spravne");
            spravne++;
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
          } else if (stavy[y]==='false' && stav=="icon_on") {
            //console.log("spatne1");
            spatne++;
            $('#odpoved_'+i+'_'+a+'').css("color","#E30613");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_on");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_off");
          } else if (stavy[y]==='false' && stav=="icon_off") {
            //
          } else if (stavy[y]==='true' && stav=="icon_off") {
            /*for (x=1; x<pocet2; x++) {
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').removeClass("icon_on");
                $('#odpoved_'+i+'_'+x+' .icon_odpoved i').addClass("icon_off");
            }*/
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').removeClass("icon_off");
            $('#odpoved_'+i+'_'+a+' .icon_odpoved i').addClass("icon_on");
            $('#odpoved_'+i+'_'+a+'').css("color","#0071BC");
            $('#odpoved_'+i+'_'+a+'').css("font-family","open_sanssemibold");
            //console.log("spatne2");
          } else {
            //console.log("nic");
            $('#odpoved_'+i+'_'+a+'').css("color","#");
          }
        }
      }

      if ((spravne<1) && (spatne<1)) {
        /*var endBox = document.getElementById("box3");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn3','.slide1','');
        $('#znovu_btn3').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz5_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if (spatne>0) {
        /*var endBox = document.getElementById("box2");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );
        returnHome('#zpet_btn2','.slide1','');
        $('#znovu_btn2').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          kviz5_anima();
        });*/
        var kapkaBox = document.getElementById("kapkaOK");
        TweenMax.to(kapkaBox, 1, {x:0, y:-185,  ease:Quint.easeOut});
        TweenMax.to(kapkaBox, 0.5, {autoAlpha:1});
      }
      if ((spatne==0) && (jsondata["sl4_kviz5_odpovedi_true"].length==spravne)) {
        var endBox = document.getElementById("box1");
        TweenMax.to(endBox, 1, {x:0, y:755,  ease:Quint.easeOut});
        TweenMax.to(endBox, 0.5, {autoAlpha:1});
        $("#banner_box").css( "z-index", "3" );

        returnHome('#zpet_btn1','.slide1','');

        $('#znovu_btn1').on("click", function() {
          $("#banner_box").css( "z-index", "1" );
          $("#banner_box").html('');
          /*$("#slide1").html('');
          $("#slide1").fadeOut( "slow", function() { });*/
          kviz5_anima();
        });
      }
    });

    $('.btn_replay').on("click", function() {
      $("#banner_box").css( "z-index", "1" );
      $("#banner_box").html('');
      //$("#banner_box").removeAttr('style');
      kviz5_anima();
    });
}
